var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

export { engineUserAgent as default };
